import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { RouteConstants } from '../../routes';
import { Forecast } from './pages/Forecast';

interface Props {}

export function Meteo(props: Props) {
  return (
    <Switch>
      <Route path={RouteConstants.meteo.forecast} component={Forecast} />
    </Switch>
  );
}
